module.exports = __webpack_public_path__ + "img/组46.82e47874.png";